import { atom } from 'recoil';

export const notificationState = atom({
	key: 'notificationState',
	default: {
		timestamp: null,
		message: '',
		severity: 'info',
	},
});
